import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import './FibLevelsOverlay.css';

export interface FibLevel {
  level: number;
  label: string;
  yPosition: number;
  price: number;
  isKey?: boolean; // Key levels like 50% and 61.8%
}

export interface FibLevelsOverlayProps {
  levels: FibLevel[];
  chartWidth: number;
}

export interface FibLevelsOverlayHandle {
  updatePositions: (positions: Map<number, number>) => void;
}

const FibLevelsOverlay = forwardRef<FibLevelsOverlayHandle, FibLevelsOverlayProps>(({ levels, chartWidth }, ref) => {
  const elRefs = useRef<Map<number, HTMLDivElement>>(new Map());

  useImperativeHandle(ref, () => ({
    updatePositions: (positions) => {
      positions.forEach((y, level) => {
        const el = elRefs.current.get(level);
        if (el) el.style.top = y + 'px';
      });
    },
  }));

  if (levels.length === 0) return null;

  return (
    <div className="fib-levels-overlay">
      {levels.map(({ level, label, yPosition, isKey }) => (
        <div
          key={level}
          ref={(el) => {
            if (el) elRefs.current.set(level, el);
            else elRefs.current.delete(level);
          }}
          className={`fib-level-line ${isKey ? 'fib-level-key' : ''}`}
          style={{
            top: `${yPosition}px`,
            width: `${chartWidth - 60}px`, // Leave space for price scale
          }}
        >
          <span className="fib-level-label">{label}</span>
        </div>
      ))}
    </div>
  );
});

export default FibLevelsOverlay;
